import { get, post, put, del } from "./api";
import type { CrmTeamPage, CrmTeamResponse, CrmTeamDetailResponse, CreateCrmTeamRequest, UpdateCrmTeamRequest, SchoolBulkOutreachRequest, BulkOutreachResult } from "../types/crm";

interface GetCrmTeamsParams {
  search?: string;
  divisions?: string[];
  states?: string[];
  pageNumber?: number;
  pageSize?: number;
}

export const getCrmTeams = (params: GetCrmTeamsParams = {}): Promise<CrmTeamPage> => {
  const query = new URLSearchParams();
  if (params.search) query.set("search", params.search);
  if (params.divisions && params.divisions.length > 0) query.set("division", params.divisions.join(","));
  if (params.states && params.states.length > 0) query.set("state", params.states.join(","));
  query.set("pageNumber", String(params.pageNumber ?? 1));
  query.set("pageSize", String(params.pageSize ?? 15));
  return get(`/api/crm/teams?${query.toString()}`);
};

export const getCrmTeamById = (id: string): Promise<CrmTeamDetailResponse> =>
  get(`/api/crm/teams/${id}`);

export const createCrmTeam = (request: CreateCrmTeamRequest): Promise<CrmTeamResponse> =>
  post("/api/crm/teams", request);

export const updateCrmTeam = (id: string, request: UpdateCrmTeamRequest): Promise<CrmTeamDetailResponse> =>
  put(`/api/crm/teams/${id}`, request);

export const deleteCrmTeam = (id: string): Promise<void> =>
  del(`/api/crm/teams/${id}`);

export const schoolBulkOutreach = (request: SchoolBulkOutreachRequest): Promise<BulkOutreachResult> =>
  post("/api/crm/teams/bulk-outreach", request);
